import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { consumeMagicLink } from "../../services/httpClient";
import useApp from "../../utils/useApp";

const MagicLogin = () => {
  const location = useLocation();
  const { setAuth, setActivePage }: any = useApp();
  const [errMsg, setErrMsg] = useState("");
  const consumed = useRef(false); // links are single-use; guard against StrictMode's double effect

  let navigate = useNavigate();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token) {
      setErrMsg("This link is invalid or has expired");
      return;
    }
    if (consumed.current) return;
    consumed.current = true;

    consumeMagicLink(token)
      .then((res: any) => {
        const profile = res[0].data;
        setAuth({ profile, admin: profile.role === "admin", twofactor: true });
        if (profile?.homepage) {
          setActivePage(profile.homepage);
          navigate(profile.homepage);
        } else {
          navigate("/");
        }
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg || "This link is invalid or has expired");
      });
  }, []);

  return (
    <div className="h-100 app-primary-alt-color align-content-center">
      <Row className="w-100 text-center">
        <Col xs={8} sm={8} md={6} lg={5} xl={4} className="m-auto">
          <Card className="p-5 shadow-sm rounded-lg d-block">
            <img src="/AndGo_Logo_Color_Horizontal.png" width="220" height="50" alt="And Go" className="mb-4" />
            {errMsg ? (
              <h5 className="mt-3 mb-3 errmsg">{errMsg}</h5>
            ) : (
              <>
                <h3 className="mt-3 mb-3 app-orange-text">Signing you in</h3>
                <Spinner animation="border" style={{ color: "#DA7E39" }} />
              </>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MagicLogin;
